import React, { useEffect, useRef, useState } from "react";
import "./Footer.css";
import { FaMapMarkerAlt, FaPhoneSquare, FaEnvelope, FaEdit, FaPlus } from "react-icons/fa";
import axios from "axios";
import { ImArrowUpRight } from "react-icons/im";
import { Base_Url } from "../config";
import Logo from "../Assests/logo.png";
import { selectUserExists } from "../redux/userSlice";
import { useSelector } from "react-redux";

const Footer = () => {
  const [currentYear, setCurrentYear] = useState('');
  const [editWhichPart, setEditWhichPart] = useState('');
  const [dosInfo, setDosInfo] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [selectedPhone, setSelectedPhone] = useState('');
  const [selectedEmail, setSelectedEmail] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [isAddMode, setIsAddMode] = useState(false);
  const [hasAddedData, setHasAddedData] = useState(false);

  const userExists = useSelector(selectUserExists);
  const statecsc = useSelector((state) => state.statecsc);
  const userfromwebmaster = useSelector((state) => state.user);

  const closeButtonRef = useRef(null);

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year);
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Base_Url}/cscinfo`);
      setDosInfo(response.data);
      
      // Check if no data exists
      if (response.data.length === 0) {
        setIsAddMode(true);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleEdit = (info, part) => {
    setEditWhichPart(part);
    setSelectedId(info.id);
    setSelectedAddress(info.address);
    setSelectedPhone(info.contact_no);
    setSelectedEmail(info.email_id);
  };

  const EmailObfuscator = ({ email }) => {
    const [isRevealed, setIsRevealed] = useState(false);
    
    const handleReveal = () => {
      setIsRevealed(true);
    };
  
    return (
      <span 
        onClick={!isRevealed ? handleReveal : undefined}
        style={{ 
          cursor: !isRevealed ? 'pointer' : 'default',
          // filter: !isRevealed ? 'blur(4px)' : 'none',
          transition: 'filter 0.3s ease',
          userSelect: 'text'
        }}
        title={!isRevealed ? " Click to reveal email" : ""}
      >
        {!isRevealed ? " Click to reveal email" :  email}
      </span>
    );
  };

  const handleAddOrUpdateSave = () => {
    if (isAddMode && !hasAddedData) {
      // Add new data
      const dataToAdd = {
        address: selectedAddress,
        contact_no: selectedPhone,
        email_id: selectedEmail
      };

      axios.post(`${Base_Url}/cscinfo`, dataToAdd)
        .then(response => {
          fetchData();
          setIsAddMode(false);
          setHasAddedData(true);
          closeButtonRef.current.click();
        })
        .catch(error => {
          console.error('Error adding dosinfo:', error);
        });
    } else {
      // Update existing data
      const dataToUpdate = {
        address: selectedAddress,
        contact_no: selectedPhone,
        email_id: selectedEmail
      };

      axios.put(`${Base_Url}/cscinfo/${selectedId}`, dataToUpdate)
        .then(response => {
          fetchData();
          closeButtonRef.current.click();
        })
        .catch(error => {
          console.error('Error updating dosinfo:', error);
        });
    }
  };

  const handleAddClick = () => {
    setEditWhichPart('Add Information');
    setSelectedAddress('');
    setSelectedPhone('');
    setSelectedEmail('');
  };

  return (
    <div>
      {/* Modal for Add/Edit */}
      <div className="modal fade" id="exampleModal5" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered modal-md" role="document">
    <div className="modal-content">
      {/* Modal Header - Centered Title */}
      <div className="modal-header" style={{ 
        backgroundColor: "#C21717", 
        color: "white", 
        justifyContent: "space-between", 
        alignItems: "center" 
      }}>
        <h5 className="modal-title w-100 text-center" id="exampleModalLabel">
          {isAddMode && !hasAddedData ? 'Add Information' : `Edit ${editWhichPart}`}
        </h5>
        <button 
          type="button" 
          className="btn-close btn-close-white" 
          ref={closeButtonRef} 
          data-bs-dismiss="modal" 
          aria-label="Close"
        ></button>
      </div>

      {/* Modal Body - Improved Layout */}
      <div className="modal-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="form-group mb-3">
                <label className="form-label">Address</label>
                <textarea 
                  onChange={(e) => setSelectedAddress(e.target.value)} 
                  value={selectedAddress} 
                  className="form-control" 
                  rows="3"
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Phone</label>
                <input 
                  type="text" 
                  value={selectedPhone} 
                  onChange={(e) => setSelectedPhone(e.target.value)} 
                  className="form-control" 
                  placeholder="Enter Phone" 
                />
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Email</label>
                <input 
                  type="email" 
                  value={selectedEmail} 
                  onChange={(e) => setSelectedEmail(e.target.value)} 
                  className="form-control" 
                  placeholder="Enter Email" 
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer - Centered Button */}
      <div className="modal-footer justify-content-center">
        <button 
          className="btn" 
          style={{ 
            background: "#c21717", 
            color: "white",
            padding: "10px 20px"
          }} 
          onClick={handleAddOrUpdateSave}
        >
          {isAddMode && !hasAddedData ? 'Add Information' : 'Save Changes'}
        </button>
      </div>
    </div>
  </div>
</div>

      {/* Rest of the Footer component remains the same */}
      <div className="upperfooter p-lg-2 p-0">
        <section className="contact-box contact-box-top theme-bg">
          <div className="container">
            <div className="row pt-lg-4  pt-0">
              {dosInfo.length === 0 && (userfromwebmaster.userExists || statecsc.userState === 0) && (
                <div className="col-12 text-center mb-3">
                  <button 
                    className="btn btn-primary" 
                    onClick={handleAddClick}
                    data-bs-toggle="modal" 
                    data-bs-target="#exampleModal5"
                  >
                    <FaPlus className="me-2" /> Add Contact Information
                  </button>
                </div>
              )}
{/* 
              {dosInfo.map((info) => (
                <React.Fragment key={info.id}>
                  <div className="col-md-4 mb-lg-4 mb-md-0">
                    <div className="contact-box text-start">
                      <div className="contact-icon">
                        <FaMapMarkerAlt className="text-white" />
                      </div>
                      <div className="contact-info">
                        <h5 className="text-white h5 contact-title font-weight-bold">ADDRESS</h5>
                        <span className="text-white contact-detail mr-2">{info.address}</span>
                        {(userfromwebmaster.userExists || statecsc.userState === 0) && (
                          <FaEdit 
                            color="white" 
                            type="button" 
                            onClick={() => handleEdit(info, "Info")} 
                            data-bs-toggle="modal" 
                            data-bs-target="#exampleModal5" 
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-lg-4 mb-md-0">
                    <div className="contact-box text-start">
                      <div className="contact-icon">
                        <FaPhoneSquare className="text-white" />
                      </div>
                      <div className="contact-info">
                        <h5 className="text-white h5 contact-title font-weight-bold">PHONE</h5>
                        <span className="text-white contact-detail mr-2">{info.contact_no}</span>
                        {(userfromwebmaster.userExists || statecsc.userState === 0) && (
                          <FaEdit 
                            color="white" 
                            type="button" 
                            onClick={() => handleEdit(info, "Info")} 
                            data-bs-toggle="modal" 
                            data-bs-target="#exampleModal5" 
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="contact-box text-start">
                      <div className="contact-icon">
                        <FaEnvelope className="text-white" />
                      </div>
                      <div className="contact-info">
                        <h5 className="text-white h5 contact-title font-weight-bold">EMAIL</h5>
                        <span className="text-white contact-detail mr-2">{info.email_id}</span>
                        {(userfromwebmaster.userExists || statecsc.userState === 0) && (
                          <FaEdit 
                            color="white" 
                            type="button" 
                            onClick={() => handleEdit(info, "Info")} 
                            data-bs-toggle="modal" 
                            data-bs-target="#exampleModal5" 
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ))} */}
            </div>
          </div>
        </section>
      </div>
{/* 
      <div className="footer page-section-pt black-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-6 sm-mb-30">
              <div className="footer-logo">
                <img
                  id="logo-footer"
                  className="mb-20 bg-white"
                  // src="https://cscdev.iitd.ac.in/maths/public/frontend/images/logo.png"
                  src={Logo}
                  alt=""
                />
              </div>
              <div className="social-icons color-hover"></div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6">
              <h6 className="text-white mb-2 mt-10 text-uppercase">
                Contact Us
              </h6>
              <div style={{ background: "#c50227", height: "2px", width: "34%" }}></div>
              <ul className="addresss-info p-0">
                <li className="d-flex align-items-start li1 mt-2">
                  <FaMapMarkerAlt className="me-3 mt-2 icons" />
                  <a className="mr-0 text-decoration-none">
                    <p className="li1">
                      {dosInfo.map((info) => (
                        <span className="text-decoration-none" key={info.id}>{info.address}</span>
                      ))}
                    </p>
                  </a>
                </li>
                <li className="li1">
                  <FaPhoneSquare className="me-3 li1 icons" />
                  <a className="mr-0 li1 text-decoration-none">
                    {dosInfo.map((info) => (
                      <span className="text-decoration-none" key={info.id}>{info.contact_no}</span>
                    ))}
                  </a>
                </li>
                <li className="li1 " style={{ cursor: "pointer" }}>
                  <FaEnvelope className="me-3 li1 icons" />
                  {dosInfo.map((info) => (
                    <span className="text-decoration-none" key={info.id}>{info.email_id}</span>
                  ))}
                </li>
              </ul>
            </div>
          </div>
          <div className="mb-2" style={{ height: "1px", background: "gray" }}></div>
          <div className="footer-widget mt-20">
            <div className="row">
              <div className="col-md-6 text-left">
                <p className="mt-15">
                  © Copyright <span>{currentYear}</span>,{' '}
                  <span className="text-white h5">Computer Services Centre, IIT Delhi</span>
                </p>
              </div>
              <div className="col-md-6 text-right">
                <p className="mt-15 h5">
                  Developed &amp; Maintained by:{" "}
                  <a href="http://csc.iitd.ac.in/" target="_blank" className="text-white h5" rel="noopener noreferrer">
                    CSC, IIT Delhi
                  </a>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
       */}
       <div className="footer page-section-pt black-bg">
  <div className="container">
    <div className="row">
      <div className="col-lg-6 col-md-6 col-sm-6 sm-mb-30">
        <div className="footer-logo" >
          <img
            id="logo-footer"
            className="mb-20 bg-white"
            src={Logo}
            alt=""
          />
        </div>
        <div className="social-icons color-hover"></div>
      </div>

      <div className="col-lg-6 col-md-6 col-sm-6 center-on-small mt-lg-0 mt-2 " >
        <h6 className="text-white mb-2 mt-10 text-uppercase">
          Contact Us
        </h6>
        <div style={{ background: "#c50227", height: "2px", width: "34%" }}></div>
        <ul className="addresss-info p-0 d-flex flex-wrap">
          <li className="d-flex align-items-center me-4 mt-3 mt-lg-0 mb-lg-4  mt-lg-2">
            <FaMapMarkerAlt className="me-2 icons" />
            <span>
              {dosInfo.map((info) => (
                <span key={info.id}>{info.address}</span>
              ))}
            </span>
          </li>
          <li className="d-flex align-items-center me-4 mt-1  mb-lg-4  mt-lg-2">
            <FaPhoneSquare className="me-2 icons" />
            <span>
              {dosInfo.map((info) => (
                <span key={info.id}>{info.contact_no}</span>
              ))}
            </span>
          </li>
          <li className="d-flex align-items-center lastli   mb-lg-4 mt-lg-2">
            <FaEnvelope className="me-2 icons" />
            <span >
              {dosInfo.map((info) => (
                <>
                {/* <span key={info.id} >{info.email_id}</span> */}
                <EmailObfuscator email={info.email_id} />
                </>
              ))}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div className="mb-2" style={{ height: "1px", background: "gray" }}></div>
    <div className="footer-widget mt-20">
      <div className="row">
        <div className="col-md-6 text-left">
          <p className="mt-15">
            © Copyright <span>{currentYear}</span>,{' '}
            <span className="text-white h5">Computer Services Centre, IIT Delhi</span>
          </p>
        </div>
        <div className="col-md-6 text-right">
          <p className="mt-15 h5">
            Developed &amp; Maintained by:{" "}
            <a href="http://csc.iitd.ac.in/" target="_blank" className="text-white h5" rel="noopener noreferrer">
              CSC, IIT Delhi
            </a>{" "}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default Footer;